export default __webpack_public_path__ + "static/media/building-icon-selected-dark.5d147239.svg";